import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { TileComponent } from '@tecalisdev/infinity';

@Component({
	selector: 'app-handset-landscape-tile',
	imports: [TranslatePipe, TileComponent],
	templateUrl: './handset-landscape-tile.component.html',
})
export class HandsetLandscapeTileComponent {}
